import React from 'react'
import { Row, Col} from 'antd'
import prettysize from '../../../utils'
import moment from 'moment'
import './efs-usage-report.scss'


export default ( {title, efsUsageData} ) => (
    <div>
        <Row className="efs-usage-container">
            <Col span={24}>
                <Row type='flex' gutter={5}>
                    <Col span={24}>
                        <h2>{title}</h2>
                    </Col>
                </Row>
                <Row type='flex' gutter={5} style={{marginTop:10}}>
                    <Col span={24}>
                        <div className='transfer-list'>
                            <div className='header'>
                                <p className='name'>Name</p>
                                <p className='file-system-id'>File system ID</p>
                                <p className='size'>Metered Size</p>
                                <p className='mount-count'>Mount Targets</p>
                                <p className='date'>Creation Date</p>
                            </div>
                           
                            {efsUsageData && efsUsageData.map((efs,i) => <EFS key={i} efs={efs} />)}
                        </div>
                    </Col>
                </Row>
                
            </Col>
        </Row>
    </div>
)


const EFS = ({ efs }) => (
    <div className='row'>
      <p className='name'>{efs.name}</p>
      <p className='file-system-id'>{efs.file_system_id}</p>      
      <p className='size'>{prettysize(efs.size_in_bytes.value)}</p>      
      <p className='mount-count'>{efs.number_of_mount_targets}</p>
      <p className='date'>{moment(efs.creation_time).format('MM/DD/YYYY')}</p>
    </div>
  )


  
  